import { Ability } from '@casl/ability';
import { createContext } from 'react';
import { AbilityType } from './hooks';

export type PermissionsContextValue = Ability<AbilityType>;

const defaultAblity = new Ability<AbilityType>();

export const PermissionsContext = createContext<PermissionsContextValue>(defaultAblity);
